const initialState = {
	counter: 0,
	dir: "right"
}

const SkillsReducer = (state=initialState,action) => {
	switch(action.type) {
		case "INCREMENT_SKILL_COUNTER":
			return {counter: state.counter+1, dir:"right"}
		case "DECREMENT_SKILL_COUNTER":
			return {counter: state.counter-1, dir:"left"}
		default:
			return state
	}
}

export default SkillsReducer